/* eslint-disable no-undef */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

export default function AdBar({ config, adVideo }) {
  useEffect(() => {
    let percentError = 0;
    const timerDuration = setInterval(() => {
      const percentVideo = (100 * adVideo.handler.currentTime) / adVideo.handler.duration;

      if (Number.isNaN(percentVideo)) {
        percentError += 1;
      }
      if (percentError > 5) {
        window.clearInterval(timerDuration);
      }
      const currentTimeBar = document
        .getElementById(config.targetId)
        .querySelector('.tpx-ext-progress-currenttime');
      if (currentTimeBar) {
        currentTimeBar.style.width = `${percentVideo}%`;
      } else {
        window.clearInterval(timerDuration);
      }

      if (adVideo.handler.completeSent || adVideo.handler.errorSent) {
        window.clearInterval(timerDuration);
      }
    }, 1000);
    return () => {
      // eslint-disable-next-line no-undef
      window.clearInterval(timerDuration);
    };
  });

  return (
    <div className={'tpx-ext-progress'}>
      <div className={'tpx-ext-progress-duration'}></div>
      <div className="tpx-ext-progress-currenttime"></div>
    </div>
  );
}

AdBar.propTypes = {
  adVideo: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired,
};
